import { useMutation, useQuery } from "@tanstack/react-query";
// * hooks
import {
  createNotification,
  uploadBrand,
  uploadFile,
  viewMedia,
  viewMediaList,
} from "../services/fileUploads";

const useFileUploadMutation = (
  token: string,
  callbackSuccess: (newValue: string) => void,
  callbackFailure: (error: any) => void
) => {
  return useMutation((file: Blob) => uploadFile(file, token), {
    onSuccess: async (data) => {
      if (callbackSuccess) {
        console.log("upload succeeded", data);
        callbackSuccess(data.data.data.objectKey);
      }
    },
    onError: async (error) => {
      if (callbackFailure) {
        callbackFailure(error);
      }
    },
  });
};

const useBrandUploadMutation = (
  token: string,
  callbackSuccess?: () => void
) => {
  return useMutation(
    ({ brandName, objectKey }: { brandName: string; objectKey: string }) =>
      uploadBrand(brandName, objectKey, token),
    {
      onSuccess: async (_) => {
        if (callbackSuccess) {
          callbackSuccess();
        }
      },
    }
  );
};

const useNotificationCreateMutation = (
  token: string,
  callbackSuccess?: () => void
) => {
  return useMutation((text: string) => createNotification(text, token), {
    onSuccess: async (_) => {
      if (callbackSuccess) {
        callbackSuccess();
      }
    },
  });
};

// const uploadBrand = (brandName: string, objectKey: string, token: string) => {
//   return axiosClient;
// };

const useMultiFileUploadMutation = (
  token: string,
  callbackSuccess: (newValueList: string[]) => void,
  callbackFailure: (_: any) => void
) => {
  return useMutation(
    (files: FileList) => {
      const mutationList: any[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        mutationList.push(uploadFile(file, token));
      }

      return Promise.all(mutationList);
    },
    {
      onSuccess: async (data) => {
        if (callbackSuccess) {
          console.log("upload multi files succeed", data);
          callbackSuccess(data.map((dataItem) => dataItem.data.data.objectKey));
        }
      },
      onError: async (error) => {
        if (callbackFailure) {
          callbackFailure(error);
        }
      },
    }
  );
};

const useMediaView = (objectKey: string, token: string) => {
  return useQuery(
    [
      "viewMedia",
      {
        objectKey,
      },
    ],
    () => viewMedia(objectKey, token),
    {
      enabled: objectKey !== "" && token !== "",
    }
  );
};

/**
 *
 * @param {string[]} objectKeyList
 * @param {string | null} token
 * @returns
 */
const useMultiMediaView = (objectKeyList: string[], token: string) => {
  return useQuery(
    [
      "viewMedia",
      {
        objectKeyData: objectKeyList.sort().join(":::"),
      },
    ],
    () => viewMediaList(objectKeyList, token),
    {
      enabled: objectKeyList.length > 0 && token !== null,
      onError: (_) => {},
    }
  );
};

export {
  useFileUploadMutation,
  useMultiFileUploadMutation,
  useMediaView,
  useMultiMediaView,
  useBrandUploadMutation,
  useNotificationCreateMutation,
};
